import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { extractPublicId } from '../../domain/format';
import { PlayerSessionService } from '../../services/player-session.service';
import { Dossier } from '../../shared/dossier/dossier';
import { PageTitle } from '../../shared/page-title/page-title';

// Accueil : reprendre sa mission, rejoindre une operation, acces organisateur.
@Component({
  selector: 'app-home-page',
  imports: [Dossier, PageTitle, RouterLink],
  templateUrl: './home-page.html',
})
export class HomePage {
  private readonly router = inject(Router);

  protected readonly latest = inject(PlayerSessionService).latest;
  protected readonly link = signal('');
  protected readonly error = signal<string | null>(null);

  protected open(event: Event): void {
    event.preventDefault();
    const publicId = extractPublicId(this.link());
    if (!publicId) {
      this.error.set('Ce lien ne mène à aucune opération.');
      return;
    }
    this.error.set(null);
    this.router.navigate(['/operations', publicId]);
  }
}
